import React, { useEffect, useState } from 'react';
import { SyncLoader } from 'react-spinners';
import styled from 'styled-components';

const AppLoader = (props) => {


  return (
    <>
      {props.load &&
        <StyledLoader>
          <main>
            <SyncLoader color={"var(--pry-color)"} margin="6" size="14" speedMultiplier="1.2" />
          </main>
        </StyledLoader>
      }
      {/* {loader &&
        <StyledLoader>
          <main>
            <SyncLoader color={"var(--pry-color)"} margin="6" size="14" speedMultiplier="1.2" />
          </main>
        </StyledLoader>
      } */}

    </>
  );
};

export default AppLoader;







const StyledLoader = styled.div`
   width: 100%;
  height: 100vh;
  background: var(--loader-bg);
  display: grid;
  place-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000 !important;
`;